// Module
var code = "<div ng-mouseenter=\"hover = true\" ng-mouseleave=\"hover = false\" style=\"max-height:100%\"> <i class=\"material-icons close-modal no-expand\" ng-class=\"{show: hover}\" ng-click=\"$ctrl.closeModal($ctrl.card.id)\"> clear </i> <nets-chat-new card=\"$ctrl.card\" context=\"modal\"></nets-chat-new> </div>";
// Exports
export default code;